import React from "react"
import {
  CheckValue,
  getAvailableUser,
} from "../../../../services/CommonFunction"
import "./Summary.scss"
import { selectIcon, SVG } from "../../../../components/UI/selector"

export default function Summary({ allUsers }) {
  if (!CheckValue(allUsers)) {
    return
  }
  const { allUsersArr } = getAvailableUser(allUsers, "not_ended")
  const usersUI = allUsersArr.map((value, index) => {
    return <UserCard key={value.user_id} user={value} rank={index + 1} />
  })
  return (
    <div className={"HRSummary box-layer2"}>
      <div className={"userCards"}>{usersUI}</div>
    </div>
  )
}

function UserCard({ user, rank }) {
  return (
    <div className={"card box-layer3 " + (user.me ? "me" : "")}>
      <img
        className={"userDP"}
        src={user.profile_pic_thumb}
        height={64}
        width={64}
      />
      <div className={"userName"}>{user.me ? "Me" : user.first_name}</div>
      <div className={"footer"}>
        <div>
          <SVG src={selectIcon("rank_icon")} height={14} />
          &nbsp;{user.calories_burnt === 0 ? "---" : rank}
        </div>
        <div>
          <img src={selectIcon("calories_icon1")} height={20} />
          &nbsp;{user.calories_burnt === 0 ? "---" : user.calories_burnt}
        </div>
      </div>
    </div>
  )
}
